/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Fragment, useState } from 'react';
import { Combobox, Transition } from '@headlessui/react';
import Chevron from '../Icons/Chevron';
import CheckIcon from '../Icons/CheckIcon';
import { XIcon } from 'lucide-react';
interface ComboBoxProps {
    bankQuestions: { id: string; name: string }[];
    selectedBankQuestions: { id: string; name: string }[];
    setSelectedBankQuestions: React.Dispatch<React.SetStateAction<{ id: string; name: string }[]>>;
}

const ComboBox: React.FC<ComboBoxProps> = ({ bankQuestions, selectedBankQuestions, setSelectedBankQuestions }) => {
    const [query, setQuery] = useState('');

    // Filter out already selected questions and apply the search query
    const filteredPeople =
        query === ''
            ? bankQuestions.filter((person) => !selectedBankQuestions.some((selected) => selected.id === person.id))
            : bankQuestions.filter((person) =>
                person.name
                    .toLowerCase()
                    .replace(/\s+/g, '')
                    .includes(query.toLowerCase().replace(/\s+/g, '')) &&
                !selectedBankQuestions.some((selected) => selected.id === person.id)
            );

    // Function to handle removing a question
    const removeQuestion = (id: string) => {
        setSelectedBankQuestions(prev => prev.filter(question => question.id !== id));
    };

    return (
        <div className="relative mt-1">
            <Combobox
                value={selectedBankQuestions}
                onChange={setSelectedBankQuestions}
                //@ts-expect-error
                multiple
            >
                <div className="mb-10 block w-full rounded-xl border border-[#d8e0df] bg-[#f8faf9] p-4 transition-all duration-200 hover:border-secondary/50 focus-within:border-secondary focus-within:bg-white focus-within:ring-4 focus-within:ring-secondary/10">
                    <Combobox.Button className="justify-between h-auto flex items-start pr-2 w-full">
                        <Combobox.Input
                            className="w-full border-none bg-transparent pr-10 text-sm font-medium leading-5 text-textPrimary placeholder:text-lightGray/70 focus:outline-none focus:ring-0"
                            onChange={(event) => setQuery(event.target.value)}
                        />
                        <Chevron className="h-5 w-5 text-lightGray" />
                    </Combobox.Button>
                </div>
                <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    afterLeave={() => setQuery('')}
                >
                    <Combobox.Options className="absolute top-10 z-50 mt-2 max-h-60 w-full overflow-auto rounded-xl border border-black/10 bg-white p-1 text-base shadow-[0_18px_55px_rgba(17,24,22,0.16)] focus:outline-none sm:text-sm">
                        {filteredPeople.length === 0 && query !== '' ? (
                            <div className="relative cursor-default select-none px-4 py-2 text-lightGray">
                                Nothing found.
                            </div>
                        ) : (
                            filteredPeople.map((person) => (
                                <Combobox.Option
                                    key={person.id}
                                    className={({ active }) =>
                                        `relative cursor-default select-none rounded-lg py-2.5 pl-10 pr-4 ${active ? 'bg-secondary/10 text-primary' : 'text-textPrimary'
                                        }`
                                    }
                                    value={person}
                                >
                                    {({ active }) => (
                                        <>
                                            <span
                                                className={`block truncate ${active ? 'font-medium' : 'font-normal'
                                                    }`}
                                            >
                                                {person.name}
                                            </span>
                                            {selectedBankQuestions.some((selected) => selected.id === person.id) && (
                                                <span
                                                    className={`absolute inset-y-0 left-0 flex items-center pl-3 text-secondary`}
                                                >
                                                    <CheckIcon />
                                                </span>
                                            )}
                                        </>
                                    )}
                                </Combobox.Option>
                            ))
                        )}
                    </Combobox.Options>
                </Transition>
            </Combobox>
            <div className="mb-2">
                {selectedBankQuestions.map((person) => (
                    <div key={person.id} className="mb-2 mr-2 inline-block items-center rounded-full bg-secondary/10 px-3 py-1 text-sm font-semibold text-primary">
                        <div className='flex items-center'>
                        {person.name}
                        <button
                            type="button"
                            className="ml-2 text-primary hover:text-secondary"
                            onClick={() => removeQuestion(person.id)}
                        >
                            <XIcon className="w-4 h-4" /> {/* Assume you have an XIcon component */}
                        </button>

                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ComboBox;
